import { Slot } from "expo-router";

import { SurveyLayout } from "~/component/layout";

const Layout = () => {
  return (
    <SurveyLayout>
      <Slot />
    </SurveyLayout>
  );
};

export default Layout;
